import { IconConfig } from "../types";

export const summerCalendar: IconConfig = {
  type: 'complex' as const,
  viewBox: "0 0 54.305 54.305",
  elements: [
    {
      type: 'g',
      id: "_x33_1_summer_calendar",
      transform: "translate(-0.75 -0.75)",
      children: [
        {
          type: 'g',
          id: "Groupe_2851",
          className: "Groupe 2851",
          transform: "translate(1 1)",
          children: [
            {
              type: 'path',
              id: "Tracé_2572",
              className: "Tracé 2572",
              d: "M49.547,6.11H46.992V3.555a2.555,2.555,0,0,0-5.11,0V6.11H12.924V3.555a2.555,2.555,0,1,0-5.11,0V6.11H5.259A4.263,4.263,0,0,0,1,10.369V49.547a4.263,4.263,0,0,0,4.259,4.259H49.547a4.263,4.263,0,0,0,4.259-4.259V10.369A4.263,4.263,0,0,0,49.547,6.11ZM43.585,3.555a.852.852,0,1,1,1.7,0v6.814a.852.852,0,0,1-1.7,0Zm-34.068,0a.852.852,0,1,1,1.7,0v6.814a.852.852,0,0,1-1.7,0ZM5.259,7.814H7.814v2.555a2.555,2.555,0,0,0,5.11,0V7.814H41.882v2.555a2.555,2.555,0,0,0,5.11,0V7.814h2.555A2.558,2.558,0,0,1,52.1,10.369v4.259H2.7V10.369A2.558,2.558,0,0,1,5.259,7.814ZM49.547,52.1H5.259A2.558,2.558,0,0,1,2.7,49.547V16.331H52.1V49.547A2.558,2.558,0,0,1,49.547,52.1Z",
              transform: "translate(-1 -1)",
              strokeWidth: "0.5"
            },
            {
              type: 'path',
              id: "Tracé_2573",
              className: "Tracé 2573",
              d: "M30.369,29a9.369,9.369,0,1,0,9.369,9.369A9.38,9.38,0,0,0,30.369,29Zm0,17.034a7.665,7.665,0,1,1,7.665-7.665A7.674,7.674,0,0,1,30.369,46.034Z",
              transform: "translate(-3.966 -5.152)",
              strokeWidth: "0.5"
            },
            {
              type: 'path',
              id: "Tracé_2574",
              className: "Tracé 2574",
              d: "M36.417,34.755a.852.852,0,1,0-1.132,1.272,4.173,4.173,0,0,1,1.352,2.445.854.854,0,0,0,.841.717.832.832,0,0,0,.136-.011.852.852,0,0,0,.706-.976,5.879,5.879,0,0,0-1.9-3.448Z",
              transform: "translate(-6.042 -5.974)",
              strokeWidth: "0.5"
            },
            {
              type: 'path',
              id: "Tracé_2575",
              className: "Tracé 2575",
              d: "M32.859,33.09A5.577,5.577,0,0,0,31.852,33a.852.852,0,0,0,0,1.7,3.845,3.845,0,0,1,.7.062.9.9,0,0,0,.157.014.852.852,0,0,0,.155-1.69Z",
              transform: "translate(-5.449 -5.745)",
              strokeWidth: "0.5"
            },
            {
              type: 'path',
              id: "Tracé_2576",
              className: "Tracé 2576",
              d: "M31.852,26.11a.851.851,0,0,0,.852-.852V21.852a.852.852,0,0,0-1.7,0v3.407A.851.851,0,0,0,31.852,26.11Z",
              transform: "translate(-5.449 -3.966)",
              strokeWidth: "0.5"
            },
            {
              type: 'path',
              id: "Tracé_2577",
              className: "Tracé 2577",
              d: "M20.931,30.135a.852.852,0,1,0,1.2-1.2l-2.409-2.409a.852.852,0,0,0-1.2,1.2Z",
              transform: "translate(-3.561 -4.748)",
              strokeWidth: "0.5"
            },
            {
              type: 'path',
              id: "Tracé_2578",
              className: "Tracé 2578",
              d: "M18.11,39.852A.851.851,0,0,0,17.259,39H13.852a.852.852,0,1,0,0,1.7h3.407A.851.851,0,0,0,18.11,39.852Z",
              transform: "translate(-2.78 -6.635)",
              strokeWidth: "0.5"
            },
            {
              type: 'path',
              id: "Tracé_2579",
              className: "Tracé 2579",
              d: "M20.931,49.149l-2.409,2.409a.852.852,0,1,0,1.2,1.2l2.409-2.409a.852.852,0,1,0-1.2-1.2Z",
              transform: "translate(-3.561 -8.103)",
              strokeWidth: "0.5"
            },
            {
              type: 'path',
              id: "Tracé_2580",
              className: "Tracé 2580",
              d: "M31.852,53a.851.851,0,0,0-.852.852v3.407a.852.852,0,0,0,1.7,0V53.852A.852.852,0,0,0,31.852,53Z",
              transform: "translate(-5.449 -8.711)",
              strokeWidth: "0.5"
            },
            {
              type: 'path',
              id: "Tracé_2581",
              className: "Tracé 2581",
              d: "M42.353,49.149a.852.852,0,0,0-1.2,1.2l2.409,2.409a.852.852,0,1,0,1.2-1.2Z",
              transform: "translate(-6.917 -8.103)",
              strokeWidth: "0.5"
            },
            {
              type: 'path',
              id: "Tracé_2582",
              className: "Tracé 2582",
              d: "M49.259,39H45.852a.852.852,0,0,0,0,1.7h3.407a.852.852,0,0,0,0-1.7Z",
              transform: "translate(-7.525 -6.635)",
              strokeWidth: "0.5"
            },
            {
              type: 'path',
              id: "Tracé_2583",
              className: "Tracé 2583",
              d: "M41.751,30.385a.849.849,0,0,0,.6-.25l2.409-2.409a.852.852,0,0,0-1.2-1.2l-2.409,2.409a.852.852,0,0,0,.6,1.454Z",
              transform: "translate(-6.917 -4.748)",
              strokeWidth: "0.5"
            }
          ]
        }
      ]
    }
  ]
}
